import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { CurrencyFormatService } from 'smartauction-frontend-micro-library';
import { DataType } from 'src/app/enums/dataType.enum';
import { TranslocoDirective } from '@jsverse/transloco';

export interface MultiErrorListModel {
  errCode: string;
  parameters?: object;
}

@Component({
    selector: 'app-multi-error-modal',
    templateUrl: './multi-error-modal.component.html',
    styleUrls: ['./multi-error-modal.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, ModalComponent]
})
export class MultiErrorModalComponent {
  @ViewChild(ModalComponent) readonly modal: ModalComponent;
  @Input() errorList: MultiErrorListModel[];
  @Input() modalHeaderText: string;
  @Output() multiErrorModalBtnSuccessAction = new EventEmitter();

  constructor(private readonly currencyFormatService: CurrencyFormatService) {}

  formatCurrency(value: string): string {
    const valueToNum = parseFloat(value.replace('$', '').replaceAll(',', ''));
    return this.currencyFormatService.formatCurrency(valueToNum);
  }

  isCurrency(item) {
    return typeof item === DataType.STRING && item.indexOf('$') !== -1;
  }

  show() {
    this.modal.show();
  }

  close() {
    this.modal.close();
  }

  continuePostingVehicle() {
    this.close();
    this.multiErrorModalBtnSuccessAction.emit(true);
  }

  /**
   *
   * @param params - Incoming params
   * @returns - constructed translation param object
   */
  constructTranslationDynamicParams(params: object) {
    const translationParams = {};
    if (params && Object.keys(params).length) {
      Object.values(params).forEach((item, index) => {
        ++index;
        if (this.isCurrency(item)) {
          item = this.formatCurrency(item);
        }
        translationParams[`parameter${index}`] = item;
      });
    }
    return translationParams;
  }
}
